import copyToClipboard from '@anm/helpers/copyToClipboard';
import stringTimeToDuration from '@anm/helpers/time/stringTimeToDuration';
import { useEffect, RefObject, useRef } from 'react';
import { Player } from '../../../types';

type HookProps = {
  player: Player | null;
  canRun: boolean;
  playerRef: RefObject<HTMLDivElement> | null;
  isVertical: boolean;
};

let timeout: NodeJS.Timer;

const useCopyCurrentTime = ({ player, canRun, playerRef, isVertical }: HookProps) => {
  const linkHolder = document.createElement('a');
  const link = useRef<HTMLAnchorElement>();

  const onCopy = (link: string) => {
    copyToClipboard(link);

    if (isVertical) {
      const timeHolder = document.querySelector('.plyr__preview-thumb__time-container');

      timeHolder?.classList.add('copied');

      return () => {
        timeHolder?.classList.remove('copied');
      };
    } else {
      linkHolder.innerHTML = `Copied!`;
      linkHolder.classList.add('active');

      return () => {
        linkHolder.innerHTML = 'Current time URL';
        linkHolder.classList.remove('active');
      };
    }
  };

  if (isVertical) {
    linkHolder.classList.add('vertical');
  } else linkHolder.innerHTML = 'Current time URL';

  const onMouseMove = (e: MouseEvent) => {
    const ref = playerRef?.current;
    if (!ref) return;

    e.stopPropagation();
    e.preventDefault();

    const timeHolder = ref?.querySelector('.plyr__preview-thumb__time-container');
    const time = timeHolder?.querySelector('span')?.innerHTML;

    const setTime = () => handleClick(`${location.href}?t=${stringTimeToDuration(time)}`);
    linkHolder.addEventListener('click', setTime);

    return () => linkHolder.removeEventListener('click', setTime);
  };

  const handleClick = (link: string) => {
    const resetState = onCopy(link);

    timeout = global.setTimeout(resetState, 2000);

    return () => clearTimeout(timeout);
  };

  const injectLink = () => {
    const ref = playerRef?.current;
    if (!ref) return;

    const thumb = ref.querySelector('.plyr__preview-thumb');
    const timeHolder = ref?.querySelector('.plyr__preview-thumb__time-container');

    if (!thumb || !timeHolder) return;

    thumb.addEventListener('mousemove', onMouseMove);
    timeHolder.appendChild(linkHolder);
    link.current = linkHolder;

    return () => thumb?.removeEventListener('mousemove', onMouseMove);
  };

  useEffect(() => {
    const ref = playerRef?.current;
    if (!ref || !player || !canRun || link.current) return;

    player.on('controlsshown', injectLink);

    return () => {
      player.off('controlsshown', injectLink);
    };
  }, [playerRef?.current, player, canRun, link.current]);
};

export default useCopyCurrentTime;
